module.exports = __webpack_public_path__ + "img/mx_seguromultidispositivo.ccd6c0c7.svg";